<div class="edit-orders-content">
  <div *ngIf="autoSaving" class="edit-orders-content-autosave">
    <div
      style="
        margin: 20% auto 0 auto;
        z-index: 200;
        background-color: transparent;
        max-width: 16rem;
      "
    >
      <app-document-progress-bar
        [color]="'white'"
        text="Automatisch speichern"
        textClass="edit-orders-content-autosave-progress-text"
        [textStyle]="{}"
      ></app-document-progress-bar>
    </div>
  </div>
  <!---->
  <div *ngIf="isAdmin">
    <div class="edit-orders-header">
      <div>{{ canSave ? "Auftrag bearbeiten" : "" }}</div>
      <div
        *ngIf="data.deleted"
        class="order-delete-hint"
        title="Kein Editieren möglich"
      >
        <span>Auftrag ist gelöscht.</span>
      </div>
      <div class="action-buttons">
        <div class="action-btn">
          <button
            *ngIf="canSave"
            title="Auftragsdaten speichern"
            mat-icon-button
            [disabled]="isSaving"
            (click)="clickSave()"
          >
            <mat-icon>save</mat-icon>
          </button>
          <button
            *ngIf="canRestore"
            title="Auftragsdaten wiederherstellen"
            mat-icon-button
            (click)="clickRestore()"
          >
            <mat-icon>restore_page</mat-icon>
          </button>
        </div>
        <div class="action-btn">
          <button
            mat-icon-button
            title="Auftragsbearbeitung verlassen"
            (click)="clickCancel()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div style="flex: 1; overflow-y: hidden">
    <div style="height: 100%; width: 100%; max-width: 100%">
      <ng-template #contentmontage>
        <div class="orders-montage-content" #mainContent>
          <div
            class="row-layout"
            style="margin-bottom: 1rem"
            [ngStyle]="{
              'justify-content': data.status === 1 ? 'flex-end' : 'center'
            }"
          >
            <div style="padding-right: 1.5rem" *ngIf="data.status === 1">
              <button
                mat-button
                class="close-order"
                (click)="closeOrder()"
              >
                Auftrag abschließen
              </button>
            </div>
            <div *ngIf="data.status === 2" class="order-closed">
              Auftrag ist abgeschlossen
            </div>
          </div>
          <div class="row-layout" style="justify-content: flex-start">
            <div style="margin-right: 4rem">
              <mat-card appearance="outlined">
                <mat-card-title>Kunde</mat-card-title>
                <mat-card-content>
                  <div *ngIf="customer">
                    {{ customer.first_name }} {{ customer.last_name }}
                  </div>
                </mat-card-content>
              </mat-card>
              <br />
              <br />
              <mat-card appearance="outlined">
                <mat-card-title>Fahrzeug</mat-card-title>
                <mat-card-content>
                  <div class="edit-orders-montage-content-row">
                    <div class="type-column">Kennzeichen</div>
                    <div class="content-column">{{ data.plate }}</div>
                  </div>

                  <div>
                    Beschreibung:
                    <br /><br />
                    {{ data.car_description }}
                  </div>
                </mat-card-content>
              </mat-card>
              <br />
              <br />
              <mat-card appearance="outlined">
                <mat-card-title>Schaden</mat-card-title>
                <mat-card-content>
                  {{ data.damage }}
                  <br />
                  <br />
                  {{ data.damage_location }}
                </mat-card-content>
              </mat-card>
            </div>
            <div>
              <mat-card appearance="outlined">
                <mat-card-title>Montage</mat-card-title>
                <mat-card-content>
                  <div class="edit-orders-montage-content-row">
                    <div class="type-column2">Datum / Zeit</div>
                    <div class="content-column">
                      {{ data.work_day }}
                      <br />
                      <br />
                      {{ data.work_from }} -
                      {{ data.work_to }}
                    </div>
                  </div>
                  <br />
                  <div class="edit-orders-montage-content-row">
                    <div class="type-column2">Ort</div>
                    <div class="content-column">
                      <div *ngIf="customer && montage_loctype === 0">
                        <div class="edit-orders-montage-read-only-row">
                          {{ customer.address }}
                        </div>
                        <div>{{ customer.zip }} {{ customer.city }}</div>
                      </div>
                      <div *ngIf="montage_loctype === 1">MAG-Werkstatt</div>
                      <div *ngIf="montage_loctype === 2">
                        <div class="edit-orders-montage-read-only-row">
                          {{ data.montage_address }}
                        </div>
                        {{ data.montage_zip }} {{ data.montage_city }}
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
              <br />
              <br />
              <mat-card appearance="outlined" *ngIf="needStatus">
                <mat-card-title style="color: red">Hinweis</mat-card-title>
                <mat-card-content>
                  <span
                    style="color: red; font-size: 1.2rem"
                    [innerHTML]="statusTip | safeHtml"
                  ></span>
                  <br />
                  <div
                    class="row-layout"
                    style="align-items: center; margin-top: 1rem"
                  >
                    <div style="margin-right: 1rem">Zahlung erhalten?</div>
                    <div>
                      <mat-radio-group
                        [value]="data.deductible_customer_status"
                        (change)="onDedStatusChange($event)"
                      >
                        <mat-radio-button
                          class="edit-orders-status-radio"
                          [value]="1"
                          [disabled]="isCompleted"
                          ><span style="color: green; font-size: 1.1rem"
                            >Ja</span
                          ></mat-radio-button
                        >
                        <mat-radio-button
                          class="edit-orders-status-radio"
                          [value]="0"
                          [disabled]="isCompleted"
                          >Nein</mat-radio-button
                        >
                      </mat-radio-group>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </ng-template>
      <!---->
      <ng-template #content>
        <div
          class="edit-orders-admin-content"
          style="padding: 0.5rem 1rem; overflow-y: auto"
          #mainContent
        >
          <div class="input-row">
            <div class="flex1">
              <app-user-autocomplete
                name="customer"
                [address]="true"
                #customerRef
                [value]="customer"
                (valueChange)="onCustomerChange($event)"
                label="Kunde"
                [required]="true"
                [readonly]="!canSave"
                [url]="customersUrl"
              >
              </app-user-autocomplete>
            </div>
            <div class="flex1 left-space">
              <app-input
                label="Abweichender Halter"
                #halter
                [(value)]="data.halter"
                [readonly]="!canSave"
                name="halter"
                [maxlength]="halterLength"
              ></app-input>
            </div>
          </div>
          <!---->
          <div class="input-row">
            <div class="flex1">
              <button
                *ngIf="canSave"
                mat-raised-button
                (click)="addCustomer()"
                class="full-size-button"
              >
                <mat-icon>add</mat-icon>
                Neuer Kunde
              </button>
            </div>
            <div class="flex1 left-space">
              <app-user-autocomplete
                name="partner"
                #partnerRef
                [value]="partner"
                (valueChange)="onPartnerChange($event)"
                label="Partner"
                [readonly]="!canSave"
                [required]="true"
                [url]="partnersUrl"
              >
              </app-user-autocomplete>
            </div>
          </div>
          <!---->
          <div
            class="input-row"
            [ngClass]="{
              'align-items-end': montage_loctype === 2,
              'align-item-center': montage_loctype !== 2
            }"
          >
            <div class="input-row flex1">
              <div style="width: 10rem">
                <app-input
                  label="Kennzeichen"
                  #plate
                  [required]="true"
                  [(value)]="data.plate"
                  [readonly]="!canSave"
                  name="plate"
                  [maxlength]="plateLength"
                ></app-input>
              </div>
              <div style="width: 10rem; margin-left: 1rem">
                <app-input
                  label="Kilometerstand"
                  #km
                  [required]="true"
                  [thousand-sep]="true"
                  [readonly]="!canSave"
                  [(value)]="data.km"
                  name="km"
                  type="number"
                ></app-input>
              </div>
              <div
                style="flex: 1; margin-left: 1rem; justify-content: flex-end"
                class="row-layout"
              >
                <div style="width: 8rem">
                  <app-input
                    label="Fahrzeugart"
                    #kind
                    [(value)]="data.kind"
                    [datalist]="kindList"
                    [readonly]="!canSave"
                    name="kind"
                    [maxlength]="carKindLength"
                  ></app-input>
                </div>
                <div style="flex: 1; margin-left: 1rem">
                  <app-input
                    label="Artikel-Nummer"
                    #article
                    [(value)]="data.articlenr"
                    [readonly]="!canSave"
                    name="articlenr"
                    [maxlength]="articleNrLength"
                  ></app-input>
                </div>
              </div>
            </div>
            <div style="flex: 1; margin-left: 2rem">
              <app-montage-location
                [data]="data"
                [address-length]="addressLength"
                [city-length]="cityLength"
                [zip-length]="zipLength"
                [loctype]="montage_loctype"
                (change)="onLocationChange($event)"
                [readonly]="!canSave"
              >
              </app-montage-location>
            </div>
          </div>

          <!---->
          <div class="input-row">
            <div style="width: 10rem">
              <app-date-picker
                [(value)]="data.first_reg"
                [compare-mode]="''"
                #firstReg
                [readonly]="!canSave"
                name="first_reg"
                label="Erstzulassung"
                [required]="true"
              >
              </app-date-picker>
            </div>

            <div class="flex1 left-space">
              <app-input
                label="Fahrzeugbeschreibung"
                #carDesc
                [readonly]="!canSave"
                [required]="true"
                [(value)]="data.car_description"
                name="car_description"
                [maxlength]="carDescLength"
              ></app-input>
            </div>
          </div>
          <!---->
          <div class="input-row">
            <div class="input-row flex1">
              <div style="width: 10rem">
                <app-date-picker
                  [(value)]="data.damage_day"
                  [compare-mode]="''"
                  #damageDay
                  [readonly]="!canSave"
                  name="damage_day"
                  label="Schadentag"
                >
                </app-date-picker>
              </div>
              <div class="flex1 left-space">
                <app-input
                  label="Schadenort"
                  #damageLoc
                  [readonly]="!canSave"
                  [required]="true"
                  [(value)]="data.damage_location"
                  name="damage_location"
                  [maxlength]="damageLocLength"
                ></app-input>
              </div>
            </div>

            <div class="input-row flex1 left-space">
              <div style="flex: 1">
                <app-input
                  label="Schadennummer"
                  #damageNr
                  [readonly]="!canSave"
                  [(value)]="data.damage_nr"
                  name="damage_nr"
                  [maxlength]="damageNrLength"
                ></app-input>
              </div>

              <div class="flex1" style="margin-left: 1rem">
                <app-input
                  label="Vers-Schein-Nr."
                  #insurance
                  [readonly]="!canSave"
                  [(value)]="data.insurance"
                  name="insurance"
                  [required]="true"
                  [maxlength]="insuranceLength"
                ></app-input>
              </div>
            </div>
          </div>
          <!---->
          <div class="input-row">
            <div style="width: 8rem">
              <app-input
                label="Selbstbeteiligung"
                #deductible
                [readonly]="!canSave"
                [required]="true"
                [(value)]="data.deductible"
                name="plate"
                (focusout)="onDeductibleFocusOut($event)"
              ></app-input>
            </div>
            <div style="width: 10rem; margin-left: 1rem">
              <app-date-picker
                [(value)]="data.work_day"
                #workDay
                [readonly]="!canSave"
                name="work_day"
                label="Leistungsdatum"
              >
              </app-date-picker>
            </div>

            <div class="flex1 left-space">
              <app-input
                label="Schadenhergang"
                #damage
                [readonly]="!canSave"
                [(value)]="data.damage"
                name="damage"
                [datalist]="damageList"
                [required]="true"
                [maxlength]="damageLength"
              ></app-input>
            </div>
          </div>
          <!-- Montage -->
          <div class="input-row">
            <div
              class="row-layout flex1"
              style="justify-content: space-between; padding-right: 1rem"
            >
              <!--flex: 1-->
              <!--
              <div style="width: 16rem">
                <mat-form-field style="width: 100%" floatLabel="always">
                  <mat-label>Montageteam</mat-label>
                  <mat-select
                    [formControl]="teamFC"
                    [compareWith]="selectById"
                    [readonly]="!canSave"
                  >
                    <mat-option *ngFor="let t of teams" [value]="t">{{
                      t.name
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            -->

              <div style="width: 16rem">
                <app-select
                  label="Montageteam"
                  [entries]="teams"
                  [readonly]="!canSave"
                  [value]="data.team?.id"
                  (change)="onChangeTeam($event)"
                ></app-select>
              </div>

              <div
                class="row-layout"
                style="
                  margin: 0 1rem 10px 1rem;
                  justify-content: flex-end;
                  align-self: center;
                "
              >
                <div>
                  <div style="padding-left: 4px">
                    <label style="font-size: 13px; color: rgba(0, 0, 0, 0.54)"
                      >Terminplanner</label
                    >
                  </div>
                  <div class="row-layout flex1" style="align-items: center">
                    <input
                      class="no-input-border"
                      style="
                        width: 5rem;
                        font-size: 1.1rem;
                        background-color: transparent;
                      "
                      placeholder="Von"
                      [readonly]="!canSave"
                      [(ngModel)]="data.work_from"
                      (change)="onTimeChange(true)"
                    />
                    <div style="padding: 4px 6px">-</div>
                    <input
                      class="no-input-border"
                      style="
                        width: 5rem;
                        font-size: 1.1rem;
                        background-color: transparent;
                      "
                      placeholder="Bis"
                      [readonly]="!canSave"
                      [(ngModel)]="data.work_to"
                      (change)="onTimeChange(false)"
                    />
                  </div>
                </div>
                <div>
                  <button
                    *ngIf="canSave"
                    mat-icon-button
                    (click)="openCalendar()"
                  >
                    <mat-icon>today</mat-icon>
                  </button>
                </div>
              </div>
              <div>
                <div style="width: 10rem">
                  <app-select
                    label="Status"
                    [entries]="statuses"
                    [readonly]="!canSave"
                    [value]="data.status"
                    (change)="onStatusChange($event)"
                  ></app-select>
                </div>

                <!--
                <mat-form-field style="width: 10rem" floatLabel="always">
                  <mat-label><b>Status</b></mat-label>
                  <mat-select [formControl]="statusFC" [readonly]="!canSave">
                    <mat-option *ngFor="let s of statuses" [value]="s">{{
                      s.text
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              --></div>
            </div>
            <div
              class="flex1 left-space row-layout"
              style="justify-content: space-between; padding: 0 1rem"
            >
              <div style="width: 10rem">
                <app-select
                  label="SB zahlt"
                  [entries]="sbTypes"
                  [readonly]="!canSave"
                  [value]="data.deductible_type"
                  (change)="onSbTypeChange($event)"
                ></app-select>
                <!--
                <mat-form-field style="width: 100%" floatLabel="always">
                  <mat-label>SB zahlt</mat-label>
                  <mat-select
                    [formControl]="sbFC"
                    [compareWith]="selectById"
                    [readonly]="!canSave"
                  >
                    <mat-option *ngFor="let t of sbTypes" [value]="t">{{
                      t.label
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              --></div>
              <div class="row-layout" style="margin-left: 1rem">
                <div style="align-self: center; white-space: nowrap">
                  SB-Anteil Kunde
                </div>
                <div style="width: 8.5rem; display: inline-block">
                  <app-select
                    label="SB zahlt"
                    [entries]="sbStates"
                    [readonly]="!canSave"
                    [value]="data.deductible_customer_status"
                    (change)="onDedStatusSelect($event)"
                  ></app-select>
                </div>

                <!--
                <mat-form-field style="width: 8.5rem" floatLabel="always">
                  <mat-label></mat-label>
                  <mat-select
                    [formControl]="sbStateFC"
                    [compareWith]="selectById"
                    [readonly]="!canSave"
                  >
                    <mat-option *ngFor="let t of sbStates" [value]="t">{{
                      t.label
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              --></div>
              <div style="width: 8rem; margin-left: 1rem">
                <app-input
                  label="SB-Betrag Kunde"
                  #sbcustomer
                  [(value)]="data.deductible_customer_part"
                  name="sbcustomer"
                  [readonly]="!canSave"
                ></app-input>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #documents>
        <div style="width: 100%; height: 100%">
          <app-order-documents-grid
            type="all"
            [doctypes]="data.doctypes"
            [id]="id"
            [readonly]="!canSave"
          ></app-order-documents-grid>
        </div>
      </ng-template>
      <ng-template #documentsvisible>
        <div style="width: 100%; height: 100%">
          <app-order-documents-grid
            type="provided"
            [doctypes]="data.doctypes"
            [canmodify]="canFillOrDelete"
            [id]="id"
            [readonly]="!canSave"
          ></app-order-documents-grid>
        </div>
      </ng-template>

      <div class="my-tab-group" *ngIf="useMyTabs">
        <div class="my-tab-group-header">
          <div
            class="my-tab"
            (click)="changeTab(0)"
            [ngClass]="{
              'my-active-tab': currentTabIdx === 0
            }"
          >
            Auftragsdaten
          </div>
          <div
            *ngIf="isAdmin"
            class="my-tab"
            (click)="changeTab(1)"
            [ngClass]="{
              'my-active-tab': currentTabIdx === 1
            }"
          >
            Dokumente
          </div>
          <div
            class="my-tab"
            (click)="changeTab(2)"
            [ngClass]="{
              'my-active-tab': currentTabIdx === 2
            }"
          >
            {{ isAdmin ? "Übergebene Dokumente" : "Dokumente" }}
          </div>
        </div>
        <div class="my-tab-group-content">
          <ng-container *ngIf="currentTabIdx === 0 && isAdmin">
            <ng-container *ngTemplateOutlet="content"></ng-container>
          </ng-container>
          <ng-container *ngIf="currentTabIdx === 0 && !isAdmin">
            <ng-container *ngTemplateOutlet="contentmontage"></ng-container>
          </ng-container>
          <ng-container *ngIf="currentTabIdx === 1 && isAdmin">
            <ng-container *ngTemplateOutlet="documents"></ng-container>
          </ng-container>
          <ng-container *ngIf="currentTabIdx === 2">
            <ng-container *ngTemplateOutlet="documentsvisible"></ng-container>
          </ng-container>
        </div>
      </div>

      <mat-tab-group
        *ngIf="!useMyTabs"
        mat-align-tabs="start"
        (selectedTabChange)="tabSelected($event)"
      >
        <mat-tab label="Auftragsdaten">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </mat-tab>
        <mat-tab
          label="Dokumente"
          bodyClass="no-tab-y-scroll"
          class="no-tab-y-scroll"
        >
          <ng-container *ngTemplateOutlet="documents"></ng-container>
        </mat-tab>
        <mat-tab label="Übergebene Dokumente">
          <ng-container *ngTemplateOutlet="documentsvisible"></ng-container>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
